import React from "react"
import BasicLayout from "../layouts/BasicLayout"

export default () => 
  <BasicLayout>
    <ul>
      <li>Keep Learning, Keep Coding</li>
      <li>Enjoy Life, Work Hard</li>
    </ul>
  </BasicLayout>
